<template>
  <nav
    class="h-12 w-full flex justify-between border-b border-gray-10 bg-white"
  >
    <div class="flex">
      <slot name="left" />
    </div>
    <div>
      <slot name="right" />
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppToolbar'
}
</script>
